import React from "react";
import InternalError from "./500";
import { AxiosError } from "axios";
import NotFound from "./404";

const ErrorContext = React.createContext('');

class ErrorBoundary extends React.Component {
    static contextType = ErrorContext;

    constructor(props) {
        super(props);
        this.state = { hasError: false };
        this.errorHandler = this.onError.bind(this);
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        if (error.message === "not-found") {
            this.setState({hasError: true, notFound: true});
        } else {
            this.setState({ hasError: true });
        }
    }

    componentDidMount() {
        window.addEventListener('error', this.errorHandler);
        window.addEventListener('unhandledrejection', this.errorHandler);
    }

    onError(event) {
        if (event instanceof PromiseRejectionEvent) {
            const { reason } = event;
            if (reason instanceof AxiosError) {
                if (reason.response?.status === 404) {
                    this.setState({hasError: true, notFound: true});
                    return;
                } else if (reason.response?.status === 403) {
                    if (reason.config.url === "/api/v1/refresh-token") {
                        localStorage.clear('user');
                        localStorage.clear('auth');
                        window.location.href = "/";
                        return;
                    }
                }
            }
        }
        this.setState({ hasError: true });
    }

    componentWillUnmount() {
        window.removeEventListener('error', this.errorHandler);
        window.removeEventListener('unhandledrejection', this.errorHandler);
    }

    render() {
        const { notFound, hasError } = this.state;
        if (hasError) {
            return (
                <ErrorContext.Provider value={{setError: this.errorHandler, resetError: () => this.setState({hasError: false})}}>
                    <div className="bg-white dark:bg-background-900 dark:text-white flex flex-row min-h-screen">
                        {notFound ? <NotFound/> : <InternalError />}
                    </div>
                </ErrorContext.Provider>
            );
        }

        return <>{this.props.children}</>;
    }
}

export {ErrorBoundary, ErrorContext};